import { h, render } from 'preact';
import ResultsApp from './components/ResultsApp';
import Ribbon from './components/Ribbon';
import AdLoader from './utils/ad-loader';

const PRIMARY_GUTEN_TAG = 'subject-2018-elections';
const RELATED_CONTENT_URL = `https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&tag=${PRIMARY_GUTEN_TAG}&tag!=object-tribcast&fields=id,url,readable_pub_date,headline,short_summary,lead_art&limit=4&format=json`;

const SKIP_URL =
  'https://www.texastribune.org/2018/03/08/more-30-texas-primary-races-are-headed-runoff-heres-what-you-need-know/';

const url =
  'https://s3.amazonaws.com/sos-test.texastribune.org/results/2018-primary.json';
const app = document.getElementById('app');
render(<ResultsApp url={url} />, app);

const ribbonContainer = document.getElementById('ribbon-container');
render(<Ribbon />, ribbonContainer);

const loader = new AdLoader({
  targetingKey: 'guten',
  targetingValue: PRIMARY_GUTEN_TAG,
});

loader.init();

const relatedContentList = document.getElementById('related-coverage-list');

fetch(RELATED_CONTENT_URL)
  .then(res => res.json())
  .then(({ results: stories }) => {
    const items = stories
      .filter(story => story.url !== SKIP_URL)
      .slice(0, 3)
      .map(story => {
        return `<li class="related-coverage__item" ga-on="click" ga-event-category="Related link" ga-event-action="${
          story.url
        }" ga-event-label="related - GutenTags"><a href="${story.url}">${
          story.headline
        }</a></li>`;
      });

    relatedContentList.innerHTML = items.join('');
  });



// WEBPACK FOOTER //
// ./main.js